import {
  FC,
  useContext,
  useEffect,
  useState,
  ChangeEvent,
  useRef,
} from "react";
import { useModalAction } from "../../components/modal-views/context";
import { useMutation } from "react-query";
import client from "../../api";
import {
  capitalizeEachFirstLetter,
  capitalizeFirstLetter,
  getCurrencyInfo,
  getErrorMessage,
  getStatusStyle,
  logger,
  makeNumberWithFloatingDigits,
} from "../../lib/utils";
import GlobalContext from "src/context/global-context";
import { useIsMounted } from "src/lib/hooks/use-is-mounted";
import { Form, InputNumber, Table } from "antd";
import {
  NetworkDisconnectMsg,
  APISomethingWrongMsg,
  LIST_PAGE_SIZE,
  SUCCESS_MODAL_TYPE,
} from "src/lib/constants";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import useAuth from "src/hooks/use-auth";
import Password from "../ui/password";
import Button from "../ui/button";
import { AdminUser } from "src/api/types";
import Input from "../ui/input";
import Input_1 from "../ui/uploadInput";
import { PermissionDataType } from "src/lib/constants/table-type";
import ToggleSwitch from "../ui/switch";
import { ColumnsType } from "antd/es/table";
import { callback } from "chart.js/dist/helpers/helpers.core";
import { getValue } from "@mui/system";
import { SpinnerIcon } from "../icons/spinner-icon";
import { EditIcon } from "../icons/edit-icon";

const schema = yup
  .object({
    cat_id: yup
      .number()
      .transform((value, originalValue) =>
        originalValue === "" ? null : value
      )
      .min(1, "Id must be greater than 0")
      .required("Required Field"),
    category_name_en: yup
      .string()
      .trim()
      .matches(
        /^[a-zA-Z]+( [a-zA-Z]+)*$/,
        "Category Name must be at least two words, do not contain numbers and special symbols!"
      )
      .required("Required Field"),
    category_name_ge: yup
      .string()
      .trim()
      .matches(
        /^[\u10A0-\u10FF ]+$/,
        "Category Name must be at least two Georgian words and cannot include numbers or special symbols!"
      )
      .required("Required Field"),
    category_name_ru: yup
      .string()
      .trim()
      .matches(
        /^[\u10A0-\u10FF\u0400-\u04FF ]+$/,
        "Category Name must be at least two words, do not contain numbers and special symbols!"
      )
      .required("Required Field"),

    services_count: yup
      .number()
      .transform((value, originalValue) =>
        originalValue === "" ? null : value
      )
      .min(0, "Must be at least 0")
      .required(),
    is_active: yup.string().required("Field is Required"),
  })
  .required();

// type CategoryFormData = yup.InferType<typeof schema>;
type FormData = yup.InferType<typeof schema>;

type CategoryFormPageProps = {
  isNew: boolean;
  editingUser?: any;
  onCallback: any;
};

const CategoryFormPage: FC<CategoryFormPageProps> = ({
  isNew,
  editingUser,
  onCallback,
}) => {
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const { openModal, closeModal } = useModalAction();

  const [dataSource, setDataSource] = useState<PermissionDataType[]>([]);

  dataSource.sort((a, b) => {
    if (a.id === 12 || a.id === 13) {
      return -1;
    }
    if (a.id === 13 || b.id === 12) {
      return 1;
    }
    return 0;
  });

  const { setIsAlertOpened, setAlertText } = useContext(GlobalContext);
  const isMounted = useIsMounted();

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    setError,
    reset,
    control,
    getValues,
    formState: { isValid, errors },
  } = useForm<FormData>({
    mode: "all",
    resolver: yupResolver(schema),
    defaultValues: {
      cat_id: -1,
      category_name_en: "",
      category_name_ge: "",
      category_name_ru: "",
      services_count: undefined,
      is_active: "",
    },
  });

  const [
    categoryId,
    categoryNameEn,
    categoryNameGe,
    categoryNameRu,
    isActive,
    serviceCount,
  ] = watch([
    "cat_id",
    "category_name_en",
    "category_name_ge",
    "category_name_ru",
    "is_active",
    "services_count",
  ]);
  const [imagePreview, setImagePreview] = useState<string | undefined>("");
  const [imageFile, setImageFile] = useState<File | null>();

  const handleFile = (e: any) => {
    const file = e.target.files?.[0];
    const previewUrl = URL.createObjectURL(file);
    setImagePreview(previewUrl);
    setImageFile(file);
  };

  useEffect(() => {
    updateWindowSize();
    window.addEventListener("resize", updateWindowSize);

    return () => window.removeEventListener("resize", updateWindowSize);
  }, []);

  function updateWindowSize() {
    setIsMobile(window.innerWidth < 640 ? true : false);
  }


  useEffect(() => {
    if (editingUser) {
      // let activeStatus = editingUser.is_active === "Y" ? "yes" : "no";
      // setValue("cat_id", editingUser.cat_id);
      // setValue("category_name_ge", editingUser.cat_name[0], {
      //   shouldValidate: true,
      // });
      // setValue("category_name_ru", editingUser.cat_name[1], {
      //   shouldValidate: true,
      // });
      // setValue("category_name_en", editingUser.cat_name[2], {
      //   shouldValidate: true,
      // });

      // setValue("is_active", activeStatus, { shouldValidate: true });
      // setValue("services_count", editingUser.services_count, {
      //   shouldValidate: true,
      // });
      // setImagePreview(editingUser.cat_image);
      fetchDetails(editingUser.key);
    } else {
    }
  }, [isNew, editingUser]);

  const { mutate: fetchDetails, isLoading: isLoadingFetchDetails } =
    useMutation(client.moneyMover.fetchCategory, {
      onSuccess: (data: any) => {
        logger.log(data, "EDITINGF");
        let activeStatus = data.is_active === "Y" ? "yes" : "no";
        setValue("cat_id", data.cat_id);
        setValue("category_name_ge", data.cat_name[0], {
          shouldValidate: true,
        });
        setValue("category_name_ru", data.cat_name[1], {
          shouldValidate: true,
        });
        setValue("category_name_en", data.cat_name[2], {
          shouldValidate: true,
        });

        setValue("is_active", activeStatus, { shouldValidate: true });
        setValue("services_count", data.services_count, {
          shouldValidate: true,
        });
        setImagePreview(data.cat_image);
      },
      onError: (error: any) => {
        if (error.code === "ERR_NETWORK") {
          setAlertText(NetworkDisconnectMsg);
        } else {
          if (error.response) {
            setAlertText(getErrorMessage(error.response.data));
          } else {
            setAlertText(APISomethingWrongMsg);
          }
        }
        setIsAlertOpened(true);
      },
    });

  const { mutate: createNew, isLoading: isLoadingCreate } = useMutation(
    client.moneyMover.addCategory,
    {
      onSuccess: (data) => {
        logger.log(data);
        openModal("CATEGORY_SUCCESS_VIEW", {
          isNew,
          callback: onCallback,
        });
      },
      onError: (error: any) => {
        if (error.code === "ERR_NETWORK") {
          setAlertText(NetworkDisconnectMsg);
        } else {
          if (error.response) {
            setAlertText(getErrorMessage(error.response.data));
          } else {
            setAlertText(APISomethingWrongMsg);
          }
        }
        setIsAlertOpened(true);
      },
    }
  );

  const { mutate: updateOne, isLoading: isLoadingUpdate } = useMutation(
    client.moneyMover.updateCategory,
    {
      onSuccess: (data) => {
        logger.log(data);
        openModal("CATEGORY_UPDATE_VIEW", {
          isNew,
          callback: onCallback,
        });
      },
      onError: (error: any) => {
        if (error.code === "ERR_NETWORK") {
          setAlertText(NetworkDisconnectMsg);
        } else {
          if (error.response) {
            setAlertText(getErrorMessage(error.response.data));
          } else {
            setAlertText(APISomethingWrongMsg);
          }
        }
        setIsAlertOpened(true);
      },
    }
  );

  const onValueChanged = (type: string, value: boolean) => {
    logger.log(type, value);
    const newData = [...dataSource];
    const index = newData.findIndex((item) => type == item.name);
    if (index > -1) {
      const item = newData[index];
      const editingData = { ...item, value };
      newData.splice(index, 1, {
        ...item,
        ...editingData,
      });
      setDataSource(newData);
    }
  };

  const onCancel = () => {
    onCallback(false);
  };

  const onSubmit = (data: FormData) => {
    if (isNew) {
      logger.log(data,"DATAAAA")
      const formData = new FormData();
      let count = serviceCount ? serviceCount : 0;
      let activeValue = isActive === "yes" ? "Y" : "N";
      formData.append("cat_id", categoryId.toString());
      let arr: string[] = [];

      Object.entries(data).forEach(([key, value]) => {
        if (key.includes("category_name")) {
          if (key === "category_name_en") {
            arr[2] = value.toString();
          } else if (key === "category_name_ge") {
            arr[0] = value.toString();
          } else if (key === "category_name_ru") {
            arr[1] = value.toString();
          }
        }
      });
      formData.append("cat_name", arr?.toString());
      formData.append("services_count", String(count));
      if (imageFile instanceof File) {
        formData.append("cat_image", imageFile);
      }
      formData.append("is_active", activeValue);

      createNew(formData);
    } else {
      let activeValue = isActive === "yes" ? "Y" : "N";
      const formData = new FormData();
      let arr: string[] = [];

      Object.entries(data).forEach(([key, value]) => {
        logger.log(key,"KEYYY")
        if (key === "is_active") {
          formData.append(key, activeValue.toString());
        } else if (key.includes("category_name")) {
          if (key === "category_name_en") {
            arr[2] = value.toString();
          } else if (key === "category_name_ge") {
            arr[0] = value.toString();
          } else {
            arr[1] = value.toString();
          }
        } else {
          formData.append(key, value.toString());
        }
      });

      if (imageFile && (imageFile as File)) {
        formData.append("cat_image", imageFile);
      }
      formData.append("cat_name", arr?.toString());
      updateOne({
        id: editingUser.key,
        payload: formData,
      });
    }
  };

  const columns: ColumnsType<PermissionDataType> = [
    {
      title: () => (
        <p className="font-manrope text-secondary text-[14px] font-medium">
          Action name
        </p>
      ),
      dataIndex: "name",
      key: "name",
      className: "w-auto",
      render: (value: string) => (
        <div className="flex flex-row gap-2 items-center">
          <p className="font-manrope text-primary text-[14px] font-medium">
            {capitalizeFirstLetter(value)}
          </p>
        </div>
      ),
    },
    {
      title: () => (
        <p className="font-manrope text-secondary text-[14px] font-medium">
          On/Off
        </p>
      ),
      dataIndex: "value",
      key: "value",
      className: "w-[80px]",
      render: (_, record: { key: React.Key; name: string; value: boolean }) => (
        <div className="flex flex-row gap-2 items-center">
          <ToggleSwitch
            type={record.name}
            value={record.value}
            onValueChanged={onValueChanged}
          />
        </div>
      ),
    },
  ];

  return (
    <>
      {isLoadingFetchDetails ? (
        <div className="flex justify-center items-center w-full h-full">
          <SpinnerIcon className="h-auto w-10 animate-spin" />
        </div>
      ) : (
        <form
          className="w-full h-full flex-col p-2 sm:p-4"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="w-full flex flex-row items-center justify-between">
            <p className="text-[25px] sm:text-[32px] font-manrope text-primary font-medium leading-[37.5px] sm:leading-[48px]">
              {isNew ? "Create New Category" : "Edit Category"}
            </p>
          </div>
          <div className="flex flex-col w-full bg-white rounded-[12px] p-4 mt-2 sm:mt-4">
            <div className="grid md:gap-[20px] gap-4 grid-cols-12">
              <div className="sm:col-span-8 col-span-12">
              <p className="text-[16px] font-semibold font-manrope text-primary">
                  Category Image
                </p>
                <div className="border-[2px] relative border-dashed h-[100px] w-[100px] border-[#9e9e9e] rounded-[100px] mt-2 bg-[#f0f0f0]">
                  <Input_1
                    label=""
                    type="file"
                    id="imageFile"
                    className="w-full h-full absolute top-0 left-0 z-[9999] cursor-pointer opacity-0"
                    disabled={editingUser ? true : false}
                    onChange={handleFile}
                  />
                  {imagePreview ? (
                    <div className="flex items-center justify-between gap-2 h-full w-full">
                      <img
                        src={imagePreview}
                        alt=""
                        className="max-w-full h-full w-full object-cover rounded-full"
                      />
                      <EditIcon className="w-[20px] h-[20px] text-primary absolute right-[-5px] bottom-[-5px]" />
                    </div>
                  ) : (
                    <div className="flex items-center justify-center h-full flex-col">
                      <div className="text-center h-[38px] flex items-center justify-center cursor-pointer">
                        {Icon}
                      </div>
                      <div className="text-center"></div>
                    </div>
                  )}
                </div>
              </div>
             
            </div>

            <div className="grid md:gap-[20px] gap-4 grid-cols-12 mt-[40px]">
              <div className="col-span-12">
                <p className="text-[20px] font-bold pb-3 font-manrope text-primary">
                  Name:
                </p>
                <div className="grid md:gap-[20px] gap-4 grid-cols-12">
                  {["Georgian", "Russian", "English"].map((item, key) => (
                    <div
                      key={key}
                      className="md:col-span-4 sm:col-span-6 col-span-12"
                    >
                      <p className="text-[16px] font-semibold font-manrope text-primary">
                        {item}
                      </p>
                      <Input
                        label=""
                        placeholder="Enter Category name"
                        className="w-full mt-2"
                        {...register(
                          item === "Georgian"
                            ? "category_name_ge"
                            : item === "Russian"
                            ? "category_name_ru"
                            : "category_name_en"
                        )}
                        error={
                          item === "Georgian"
                            ? (errors?.category_name_ge?.message as string)
                            : item === "Russian"
                            ? (errors?.category_name_ru?.message as string)
                            : (errors?.category_name_en?.message as string)
                        }
                      />
                    </div>
                  ))}
                </div>
              </div>
              <div className="sm:col-span-4 col-span-12">
                <p className="text-[16px] font-semibold font-manrope text-primary">
                  Money Mover Category Id:
                </p>
                <div className="">
                  <Input
                    label=""
                    placeholder="Enter Momey Mover Category Id"
                    className="w-full mt-2"
                    value={
                      categoryId === -1 || categoryId === 0 ? "" : categoryId
                    }
                    {...register("cat_id")}
                    error={errors && (errors?.cat_id?.message as string)}
                  />
                </div>
              </div>
              <div className={`md:col-span-4 sm:col-span-6 col-span-12 `}>
                <p className="text-[16px] font-semibold font-manrope text-primary">
                  Service Count{" "}
                </p>
                <Input
                  label=""
                  type="number"
                  id="services_count"
                  className="w-full mt-2"
                  // disabled={editingUser ? true : false}
                  {...register("services_count")}
                  error={
                    errors.services_count &&
                    (errors.services_count.message as string)
                  }
                />
              </div>{" "}
              <div className={`md:col-span-4 sm:col-span-6 col-span-12 block`}>
                <p className="text-[16px] font-semibold font-manrope text-primary">
                  Is Category Active
                </p>
                <div className="flex items-center gap-2 mt-2">
                  <div className="flex-1">
                    <label
                      className={`${
                        isActive == "yes"
                          ? "border-[#c3e600] bg-[#c3e600]"
                          : "border-[#ddd] bg-[#ddd]"
                      } flex items-center gap-1 h-[63px] text-[16px] font-semibold relative w-full justify-center border rounded-[10px] `}
                    >
                      <input
                        type="radio"
                        value="yes"
                        className="absolute top-0 left-0 w-full h-full z-[999] cursor-pointer opacity-0"
                        // disabled={!!editingUser}
                        {...register("is_active")}
                      />
                      Yes
                    </label>
                  </div>
                  <div className="flex-1">
                    <label
                      className={`${
                        isActive == "no"
                          ? "border-[#c3e600] bg-[#c3e600]"
                          : "border-[#ddd] bg-[#ddd]"
                      } flex items-center gap-1 h-[63px] text-[16px] font-semibold relative w-full justify-center border rounded-[10px] `}
                    >
                      <input
                        type="radio"
                        className="absolute top-0 left-0 w-full h-full z-[999] cursor-pointer opacity-0"
                        value="no"
                        // disabled={!!editingUser}
                        {...register("is_active")}
                      />
                      No
                    </label>
                  </div>
                </div>
              </div>{" "}
            </div>

            <div className="w-full flex flex-row items-center justify-start gap-2 mt-2 mt-[70px] pt-5 border-t border-[#ddd]">
              <Button
                variant="solid"
                className="w-full sm:w-[230px] rounded-[10px] font-manrope text-[16px] font-bold leading-[24px] h-[56px] bg-[#BCBEAD] hover:bg-light-600"
                onClick={onCancel}
              >
                Cancel
              </Button>
              <Button
                variant="validate"
                type="submit"
                className="w-full sm:w-[230px] rounded-[10px] font-manrope text-[16px] font-bold leading-[24px] h-[56px]"
                disabled={!isValid || isLoadingCreate || isLoadingUpdate}
                isLoading={isLoadingCreate || isLoadingUpdate}
              >
                {isNew ? "Save" : "Update"}
              </Button>
            </div>
          </div>
        </form>
      )}
    </>
  );
};

export default CategoryFormPage;

const Icon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 12C17 13.7 15.7 15 14 15C12.3 15 11 13.7 11 12C11 10.3 12.3 9 14 9C15.7 9 17 10.3 17 12ZM22 7V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V7C2 5.9 2.9 5 4 5V4H8V5H10L11 3H17L18 5H20C21.1 5 22 5.9 22 7ZM7.5 9C7.5 8.2 6.8 7.5 6 7.5C5.2 7.5 4.5 8.2 4.5 9C4.5 9.8 5.2 10.5 6 10.5C6.8 10.5 7.5 9.8 7.5 9ZM19 12C19 9.2 16.8 7 14 7C11.2 7 9 9.2 9 12C9 14.8 11.2 17 14 17C16.8 17 19 14.8 19 12Z"
      fill="black"
    />
  </svg>
);
